import { Environment } from 'modules/LoginApp/types'

export const getDashboardDomain = (environment?: Environment) => {
  switch (environment) {
    case 'production':
      return 'dashboard.sequencehq.com'
    case 'sandbox':
      return 'dashboard.sandbox.sequencehq.com'
    case 'dev':
    default:
      return 'dashboard.seqhq.io'
  }
}
